import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';

import { PlataformaBadgeComponent } from './plataforma-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PlataformaBadgeComponent
    ],
    exports: [
        PlataformaBadgeComponent
    ]
})
export class PlataformaBadgeModule { }
